import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useStorefrontTenantSettings } from './useStorefrontTenantSettings'

function SettingRow({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="flex items-center justify-between px-4 py-5">
      <span className="text-sm font-medium">{label}</span>
      {children}
    </div>
  )
}

function Divider() {
  return <div className="border-t border-border mx-4" />
}

export function ShippingSettings() {
  const { settings, isLoading } = useStorefrontTenantSettings()

  return (
    <Card className="rounded-2xl border-0">
      <CardContent className="p-0">
        <SettingRow label="Shipping Cost Display">
          {isLoading ? (
            <Skeleton className="w-32 h-4 rounded-md" />
          ) : (
            <span className="text-sm text-muted-foreground">
              {settings?.shipping_cost_text || '—'}
            </span>
          )}
        </SettingRow>

        <Divider />

        <SettingRow label="Delivery Estimate">
          {isLoading ? (
            <Skeleton className="w-32 h-4 rounded-md" />
          ) : (
            <span className="text-sm text-muted-foreground">
              {settings?.shipping_delivery_text || '—'}
            </span>
          )}
        </SettingRow>
      </CardContent>
    </Card>
  )
}
